<template>
  <div id="app">
    <verification-success />
  </div>
</template>

<script>
import VerificationSuccess from './components/verificationSuccess';
import { mapActions } from 'vuex';

export default {
    name: 'App',
    components: { VerificationSuccess },
    data() {
        return {};
    },
    methods: {
        ...mapActions({
            setTranslations: 'setTranslations'
        })
    },
    mounted() {
        if (Object.keys(window.translationString).length > 0) {
            this.setTranslations(window.translationString);
        }
    }
};
</script>

<style lang="scss">
@import "~@nuskin/ns-core-styles/src/scss/buttons";
@import "~@nuskin/ns-core-styles/src/scss/typographyVariables";
@import "~@nuskin/ns-core-styles/src/scss/global.mixins";
@import '~@nuskin/ns-core-styles/src/scss/colors';

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
